import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as application from '../actions/application-detail.actions';
import * as applicationDelete from '../actions/application-delete.actions';
import * as applicationList from '../actions/application-list.actions';
import { AppsRestClient } from '../services/apps-rest-client.service';
import * as message from '../../../core/actions/message.actions';
import { AppMessage } from '../../../core/model/app-message.model';
import { ApplicationsState } from '../applications.state';
import { Action, Store } from '@ngrx/store';
import { selectEnabledApplicationList, selectEnabledApplicationParams } from '../application.selector';
import { ApplicationList } from '../model/application/application-list.model';
import * as RouterActions from '../../../core/actions/router.actions';
import { asRouterParamsCheckLastItem } from '../../shared/helper/router-params';
import { ModuleRoutingConstants } from '../../../core/helpers/module-routing.constants';
import { ApplicationListParams } from '../model/application-list-params';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/withLatestFrom';

@Injectable()
export class ApplicationDeleteEffects {

    /**
     * Side effect to trigger delete application request.
     */
    @Effect() triggerDeleteApplication$ = this.actions$
        .ofType(application.DELETE)
        .map((action: application.DeleteAction) => new applicationDelete.DeleteRequestAction(action.payload.appId));

    /**
     * Side effect to delete application.
     */
    @Effect() deleteRequest$ = this.actions$
        .ofType(applicationDelete.DELETE_REQUEST)
        .switchMap((action: applicationDelete.DeleteRequestAction) => this.deleteApplication(action.payload));

    /**
     * Side effect to reload list of applications - to refresh page of displayed applications.
     */
    @Effect() refreshApplications$ = this.actions$
        .ofType(applicationDelete.DELETE_SUCCESS)
        .withLatestFrom(this.store.select(selectEnabledApplicationList), this.store.select(selectEnabledApplicationParams))
        .mergeMap(([, list, params]: ([applicationDelete.DeleteSuccessAction, ApplicationList, ApplicationListParams])) => {

            const actions: Action[] = [
                new message.MessageShowAction(AppMessage.newSuccessMessage('APPLICATIONS.MESSAGES.APPLICATION-DELETED'))
            ];

            // SSF-253 / ALM 49302: Stránkování při smazání aplikace
            // if deleted application is the only item on a page then it is required to load previous page instead of refresh of current page
            if (list.applications.length === 1) {

                actions.push(
                    new RouterActions.Go({
                        path: ModuleRoutingConstants.APPLICATIONS_ROUTER,
                        query: asRouterParamsCheckLastItem(params)
                    })
                );

            } else {
                actions.push(new applicationList.LoadRequestAction());
            }

            return actions;
        });

    /**
     * Function to delete application. If deleted then success action is returned error action otherwise.
     * @param appId id of app to be deleted
     */
    private deleteApplication = (appId) => this.client.deleteApplication(appId)
        .map(() => (new applicationDelete.DeleteSuccessAction(appId)))
        // If request fails, dispatch failed action
        .catch(error => Observable.of(new applicationDelete.DeleteErrorAction(error)));

    constructor(private store: Store<ApplicationsState>,
                private client: AppsRestClient,
                private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/effects/application-delete.effects.ts